import React, { useEffect, useState, useContext } from 'react';
import { Link } from "react-router-dom";
import Layout from '../../parts/Layout';
import { httpRequest } from '../../../services/httpService';
import helpers from '../../../services/helpers';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
//import Dropdown from 'react-bootstrap/Dropdown'
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import initTreeView from '../../../services/initTreeView';
import ProfileContext from '../../../services/profileContext';
import { getApiData } from '../../../services/apiService';
import { CiShare1 } from "react-icons/ci";
import { FaInfoCircle } from "react-icons/fa";
import EmployeesFormModal from '../../app/hr/EmployeesFormModal';
import store from '../../../services/store';
import { SplitButton } from 'primereact/splitbutton';

import ActionMenu from '../../../services/ActionMenu';

export default function UsersList ({viewer = 'admin', menu = 'users', page_title = "Manage Users"}){
    const {
        account
    } = useContext(ProfileContext);
    //const default_currency = helpers.getSettingValue(account?.settings, 'default_currency', 'PHP');

    const [record_data, setRecordData] = useState([]);
    const [loading, setLoading] = useState(1);
    const [search_key, setSearchKey] = useState('');
    const [data_table, setDataTable] = useState([]);
    const [selected_items, setSelectedItems] = useState([]);
    const [reference_id, setReferenceID] = useState('');
    const [show_modal, setShowModal] = useState(0);
    const [filters, setFilters] = useState({
        first: 0,
        rows: 10,
        page: 0,
        sortField: null,
        sortOrder: null,
        entity_type: ''
    });

    useEffect(() => {
        initTreeView()
        // fetchDataList({
        //     "page": filters.page + 1,
        //     "per_page": filters.rows
        // })
    }, []);

    // useEffect(() => {
    //     displayDataTable(record_data)
    // }, [filters.sortOrder]);

    useEffect(() => {
        displayDataTable(record_data)
    }, [
        selected_items
    ]);

    useEffect(() => {
        // fetchDataList({
        //     "page": filters.page + 1,
        //     "per_page": filters.rows,
        //     "search": search_key
        // })

        if(filters.entity_type || filters.rows || filters.page){
            fetchDataList()
        }
    }, [
        //filters
        filters.entity_type,
        filters.rows,
        filters.page
    ]);
    
        useEffect(() => {
            if(search_key){
                fetchDataList()
            }
        }, [
            search_key
        ]);

    async function fetchDataList(condition = {
        "page": '',
        "search": '',
        "per_page": ''
    }){
        // const page = condition.page ?? filters.page
        // const per_page = condition.per_page ?? filters.rows
        // const search = condition.search ?? search_key

        const page = filters.page + 1
        const per_page = filters.rows
        const search = search_key

        let filter = `?paginate=1&`

        if(page){
            filter += 'page='+page+'&'
        }
        if(per_page){
            filter += 'per_page='+per_page+'&'
        }
        if(search){
            filter += 'search='+search+'&'
        }
        if(filters.entity_type){
            filter += 'entity_type='+filters.entity_type+'&'
        }

        filter = filter.slice(0, -1)

        setLoading(1)

        let endpoint = helpers.createUrl(`V1/users${filter}`)
        // setLoading(1)
        const res = await getApiData(endpoint, false)

        if(res.status === 'error'){
            Swal.fire({
                title: "Error!",
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
            });
            setLoading(0)
        }
        else{
            setRecordData(res)
            setLoading(0)
            displayDataTable(res)
        }
    }
    
    function search(e){
        let { value } = e.target;
        setSearchKey(value)
        fetchDataList({
            "page": filters.page + 1,
            "search": value
        })
    }

    function triggerAction(data = '', action = '', status = ''){
        let ids = [];
        if(action === 'single-delete'){
            ids.push(data.id)
        }
        else{
            ids = data.map(o => o['id']);
        }

        let title = 'Delete User'
        if(ids.length > 1){
            title = 'Delete Users'
        }

        Swal.fire({
            title: title,
            text: 'This action cannot be reversed. All associated records will also be deleted. Do you want to continue?',
            showCancelButton: true,
            showConfirmButton: false,
            closeOnCancel: true,
            showDenyButton: true,
            denyButtonText: 'Yes'
        })
        .then((result) => {
            if (result.isDenied) {
                deleteItem(ids)
            }
        })
    }

    function deleteItem(id){
        const url = helpers.createUrl('V1/users/delete')
        httpRequest(url, 'POST', {
            postdata: {
                "ids": id
            },
        }, true)
            .then((res) => {
                setLoading(0)
                fetchDataList({
                    "page": filters.page + 1,
                    "per_page": filters.rows,
                    "search": search_key
                })
                setSelectedItems([])

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                })
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                setSelectedItems([])

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    function displayDataTable(data){
        const userActions = [
            { 
                label: 'Edit User', 
                icon: 'fas fa-pencil-alt', 
                to: (row) => `/account/users/${row.id}/edit` 
            },
            { separator: true },
            { 
                label: 'Delete', 
                icon: 'fas fa-trash', 
                className: 'text-danger',
                command: (row) => triggerAction(row, 'single-delete')
            }
        ];

        setDataTable(
            <DataTable 
                className='border-top'
                dataKey={data.id}
                value={data.data} 
                // tableStyle={{ minWidth: '50rem' }}
                size="normal"
                paginator 
                rows={data.per_page} 
                rowsPerPageOptions={[5, 10, 20, 25, 50]}
                totalRecords={data.total}
                onPage={onPage}
                first={filters.first}
                lazy
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                selection={selected_items} 
                onSelectionChange={onSelectItem}
                scrollHeight="500px"
                scrollable
                responsive={true}
                emptyMessage="No data to display"
            >
                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                <Column field="id" header="ID" ></Column>
                <Column field="display_name" header="NAME" ></Column>
                <Column field="email" header="EMAIL" ></Column>
                <Column header="ROLE" body={({role_name}) => role_name ? role_name : '---' }/>
                <Column header="LINKED PROFILE" body={({entity_type, reference_id}) => {
                    if(entity_type === 'employee'){
                        return <Link onClick={() => {
                                        setShowModal(1)
                                        setReferenceID(reference_id)
                                    }
                                }><FaInfoCircle /> Employee</Link>
                    }
                    else if(entity_type === 'customer'){
                        return <Link to={`/customers/${reference_id}/edit`}><FaInfoCircle/> Customer</Link>
                    }
                    else if(entity_type === 'vendor'){
                        return <Link to={`/vendors/${reference_id}/edit`}><FaInfoCircle/> Vendor</Link>
                    }
                    else{
                        return 'System';
                    }
                }}/>
                <Column className="text-right" body={(rowData) => <ActionMenu data={rowData} actions={userActions} />} style={{ maxWidth: '50px' }}></Column> 
            </DataTable>
        )

    }

    const onPage = (e) => {
        setFilters(e)
        setSelectedItems([])
    };

    const onSelectItem = (e) => {
        const value = e.value;
        setSelectedItems(value);
    };

    function displayActionMenu(data){
        const items = [
            { 
                label: 'Edit', 
                icon: 'fas fa-pencil-alt', 
                template: (item, options) => {
                    // Using template to integrate React Router Link
                    return (
                        <Link to={`/account/users/${data.id}/edit`} className={options.className}>
                            <span className={options.iconClassName}></span>
                            <span className={options.labelClassName}>{item.label}</span>
                        </Link>
                    );
                }
            },
            { separator: true }, // Replaces Dropdown.Divider
            { 
                label: 'Delete', 
                icon: 'fas fa-trash', 
                className: 'text-danger', // Custom text color
                command: () => triggerAction(data, 'single-delete') 
            }
        ];

        return (<SplitButton 
                    label="Action"
                    model={items}
                    icon=""
                    severity="secondary" // Replaces btn-light/border
                    size="small"         // Replaces size="sm"
                    outlined 
                    menuButtonProps={{ 
                        style: { borderRadius: '4px' }, // Restores radius on the left side
                        className: 'border-0 shadow-none'
                    }}
                    buttonProps={{ 
                        style: { display: 'none' } // Hides the primary action half
                    }}
                    dropdownIcon="fas fa-ellipsis-v"
                    className="border-0"
                />)
        // return (
        // <Dropdown>
        //                 <Dropdown.Toggle className='btn-light border' size="sm" id={"dropdown-actions-"+data.id}>Action</Dropdown.Toggle>
        //                 <Dropdown.Menu align="end">
        //                     <Dropdown.Item key="edit" as={Link} to={`/account/users/${data.id}/edit`}><i className="fas fa-pencil-alt mr-2" />Edit</Dropdown.Item>
        //                     <Dropdown.Divider />
        //                     <Dropdown.Item key="delete" className='text-danger' onClick={(e) => triggerAction(data, 'single-delete')}><i className="fas fa-trash mr-2" />Delete</Dropdown.Item>
        //                 </Dropdown.Menu>
        //             </Dropdown>
        //             )
    }

    function handleSave(){
        //fetchDataList()
    }

    
    function inputChange(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            if (e.target.checked) {
                value = 1;

                if(name == 'warranty_status') value = 'active'
            } else {
                value = 0;

                if(name == 'warranty_status') value = 'expired'
            }
        }
        else if (e.target.type === "file") {
          value = e.target.files[0]
        }

        let new_state = { [name]: value }

        setFilters({ ...filters, ...new_state });
    }

    return (
        <>
        <EmployeesFormModal 
            show_modal={show_modal} 
            close_modal={setShowModal} 
            handleSave={handleSave}
            id={reference_id}
        />
        <Layout page_title={page_title} menu={menu} parent_text="Account">
            <div className="container-fluid" style={{position: 'relative'}}>
                <Loader isLoading={loading}/>
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header border-bottom-0">
                                <div className="row">
                                    <div className="col-lg-8">
                                        {/* <input type="text" className="form-control" placeholder="Search" onChange={search} /> */}
                                        <div className="row">
                                            <div className="col-md-4 col-lg-4 mb-2">
                                                <Dropdown  
                                                    name='entity_type'
                                                    value={filters.entity_type}
                                                    className='w-100'
                                                    onChange={inputChange}
                                                    options={store.user_entity_types} 
                                                    optionLabel="name" 
                                                    optionValue="id" 
                                                    placeholder="Filter User Type" 
                                                    checkmark={true} 
                                                    highlightOnSelect={false}
                                                    showClear
                                                    filter 
                                                />
                                            </div>
                                            <div className="col-md-4 col-lg-4 mb-2">
                                                <InputText
                                                    id="search" 
                                                    name="search" 
                                                    value={search_key}
                                                    tagClass="form-control mb-0 w-100"
                                                    placeholder="Search"
                                                    onChange={search}
                                                    autoFocus={true}
                                                    className='w-100'
                                                />
                        
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 text-right mt-3 mt-md-0">
                                        <Link className='btn btn-primary float-right' to="/account/users/new"><i className="fas fa-plus-circle mr-2" />New</Link>
                                
                                        {selected_items.length ?
                                        <Dropdown className='float-right mr-3'>
                                            <Dropdown.Toggle className='btn-light border' id={"dropdown-actions-"}>Bulk Action</Dropdown.Toggle>
                                            <Dropdown.Menu align="end">
                                                <Dropdown.Item key="delete" className='text-danger' onClick={(e) => triggerAction(selected_items)}><i className="fas fa-trash mr-2" />Delete</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown> : ''}
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-0">
                                { data_table }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
        </>
    )
}